export const LANGUAGES: Array<string> = [
  'en',
  'de',
  'es',
  'fr',
  'ru'
]
